import { supabase } from "../supabase/supabaseClient";

export const getExperiences = async (userId) => {
    return await supabase
        .from("player_experiences")
        .select("*")
        .eq("user_id", userId)
        .order("start_date", { ascending: false });
};

export const createExperience = async (userId, experience) => {
    return await supabase
        .from("player_experiences")
        .insert([{ user_id: userId, ...experience }])
        .select()
        .single();
};

export const updateExperience = async (experienceId, updates) => {
    return await supabase
        .from("player_experiences")
        .update(updates)
        .eq("id", experienceId)
        .select()
        .single();
};

export const deleteExperience = async (experienceId) => {
    return await supabase
        .from("player_experiences")
        .delete()
        .eq("id", experienceId);
};
